import {combineReducers} from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import {presentationModuleReducer} from "./presentations/reducer"

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  presentationModuleReducer,
});

export default reducers;